var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2H13C13 2 14 2 14 3V3.66667C14 3.66667 14 4.66667 13 4.66667H3C3 4.66667 2 4.66667 2 3.66667V3C2 3 2 2 3 2Z",
    fill: "#9872FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.66675H13C13 6.66675 14 6.66675 14 7.66675V8.33341C14 8.33341 14 9.33342 13 9.33342H3C3 9.33342 2 9.33341 2 8.33341V7.66675C2 7.66675 2 6.66675 3 6.66675Z",
    fill: "#9872FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.3333H13C13 11.3333 14 11.3333 14 12.3333V12.9999C14 12.9999 14 13.9999 13 13.9999H3C3 13.9999 2 13.9999 2 12.9999V12.3333C2 12.3333 2 11.3333 3 11.3333Z",
    fill: "#9872FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationMenu);
export default __webpack_public_path__ + "static/media/Navigation_Menu.1a0cf91d.svg";
export { ForwardRef as ReactComponent };